export const typographyTokens = {
    family: {
        heading: '"Inter", sans-serif',
        body: '"Inter", sans-serif'
    },
    weight: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800
    },
    size: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.5rem',
        '7xl': '4rem'
    },
    lineHeight: {
        xs: 1.5,
        sm: 1.5,
        base: 1.5,
        lg: 1.5,
        xl: 1.5,
        '2xl': 1.3,
        '3xl': 1.3,
        '4xl': 1.3,
        '5xl': 1.5,
        '6xl': 1.3,
        '7xl': 1.3
    },
    letterSpacing: {
        tight: '-0.01em',
        normal: '0em'
    }
};

export default typographyTokens;
